/**
 * Normalize dashboard / narration intake navigation state for create-flow pages.
 * @param {object|null|undefined} locationState
 */
export function getIntakeNavPrefill(locationState) {
  if (!locationState) return null;
  const recommended =
    locationState.recommendedParams || locationState.quickIntake?.recommendedParams || {};
  const prefill = locationState.prefill || {};
  const quick = locationState.quickIntake || {};
  const text =
    prefill.shortIdea ||
    recommended.topic ||
    quick.text ||
    quick.transcript ||
    recommended.full_script ||
    '';
  return {
    recommended,
    prefill,
    quick,
    title: prefill.title || recommended.title || quick.classification?.title_suggestion || '',
    text: String(text || '').trim(),
    songUrl: prefill.songUrl || recommended.song_url || quick.audioUrl || '',
    audioFilename: quick.audioFilename || '',
    fullScript: prefill.fullScript || recommended.full_script || text,
    newsTopic: prefill.newsTopic || recommended.news_topic || text,
    pitchScript: prefill.pitchScript || recommended.pitch_script || text,
    tutorialTopic: prefill.tutorialTopic || recommended.tutorial_topic || text,
    language: prefill.language || recommended.language || '',
    tone: prefill.tone || recommended.tone || '',
    visualStyle: prefill.visualStyle || recommended.visual_style_ui || recommended.visual_style || '',
    optionalLyrics: prefill.optionalLyrics || recommended.optional_lyrics || quick.transcript || '',
    mode: recommended.mode || prefill.mode || '',
  };
}
